export default defineAppConfig({
    headTitle: 'Yippcms',
    cms: {
        header: {
            logo: { src: '/assets/images/rood-letter-193.png', alt: 'Yipp' },
        },
    },
})
